const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.6623 0.666265V4.66385V11.9928C14.6665 13.1999 13.8589 14.2591 12.6938 14.5746C11.5287 14.8901 10.297 14.3831 9.69156 13.3388C9.08617 12.2945 9.25827 10.9737 10.1111 10.1194C10.9638 9.26506 12.2843 9.09061 13.3297 9.69415V5.45005L6.66708 6.56271V13.3253C6.67134 14.5324 5.86375 15.5916 4.69862 15.9071C3.53349 16.2226 2.30178 15.7156 1.69639 14.6713C1.09099 13.627 1.2631 12.3062 2.11588 11.4519C2.96867 10.5976 4.28917 10.4231 5.33455 11.0267V1.99879C5.33186 1.90121 5.34768 1.804 5.38119 1.7123L5.42782 1.63901C5.45277 1.59216 5.48175 1.54757 5.51444 1.50576L5.58773 1.44579L5.70766 1.36584H5.8076L5.89421 1.33253L13.8894 0H13.936H13.996C14.036 0.0153597 14.074 0.0354932 14.1093 0.0599638H14.2225C14.2749 0.0839763 14.3261 0.110662 14.3758 0.139916C14.3957 0.179891 14.4424 0.179891 14.4424 0.179891C14.4896 0.227354 14.53 0.281174 14.5623 0.339795L14.6023 0.393096C14.6414 0.478885 14.6618 0.571992 14.6623 0.666265ZM2.66949 13.3253C2.66949 14.0612 3.26608 14.6578 4.00202 14.6578C4.73795 14.6578 5.33455 14.0612 5.33455 13.3253C5.33455 12.5894 4.73795 11.9928 4.00202 11.9928C3.26608 11.9928 2.66949 12.5894 2.66949 13.3253ZM6.66708 5.21019V2.54513L13.3297 1.45246V4.11752L6.66708 5.21019ZM10.6647 11.9928C10.6647 12.7287 11.2613 13.3253 11.9972 13.3253C12.7331 13.3253 13.3297 12.7287 13.3297 11.9928C13.3297 11.2568 12.7331 10.6602 11.9972 10.6602C11.2613 10.6602 10.6647 11.2568 10.6647 11.9928Z",
  fill: "#8FB0D4"
});

const SvgUploadAudio = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUploadAudio, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upload-audio.9caad029.svg";
export { ForwardRef as ReactComponent };